import { useLookbookOptions } from '@app/utils/hooks/lookbook/useLookbookOptions';

import { Button } from '../various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '../various/Dropdown';
import { MoreVerticallySmall } from '../various/Icons';

import { useLookbookListingContext } from './context/LookbookListingContext';

interface Props {
  lookbookId: string;
}

export const LookbookOptionsColumn = ({ lookbookId }: Props) => {
  const items = useLookbookOptions({ lookbookId });
  const { setSelectedLookbookId } = useLookbookListingContext();

  const handleClick = () => {
    setSelectedLookbookId(lookbookId);
  };

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          icon={MoreVerticallySmall}
          color="secondary"
          variant="text"
          className="z-interactiveTableItem size-10"
          onClick={handleClick}
        />
      </DropdownTrigger>
      <DropdownMenu items={items} />
    </Dropdown>
  );
};
